import { useResultPopupModuleDispatch, RESULT_POPUP_MODULE_ACTION, POPUP_TYPE } from "..";
import { useCallback } from "react";

export default function useShowPopup() {
    const dispatch = useResultPopupModuleDispatch();

    return useCallback((isCorrect: boolean, triesLeft: number) => {
        console.log('showPopup', isCorrect, triesLeft)
        dispatch({
            type: RESULT_POPUP_MODULE_ACTION.SHOW,
            payload: {
                type: isCorrect ? POPUP_TYPE.CORRECT : POPUP_TYPE.WRONG,
                triesLeft,
                isDisplayed: true
            }
        })
    }, [dispatch])
}
